export default __webpack_public_path__ + "static/media/frame_ko_pc@2x.7d583c63.png";